/*
 * Éloence — calcul du Profil Olfactif (fonction pure, sans DOM).
 * Chargé dans le navigateur (window.ElQuizProfile) et dans Node (require) pour les tests.
 *
 * PERFUMES est la seule liste des identifiants parfum côté JS. Son ordre est
 * l'ordre de priorité fixe utilisé en dernier recours pour départager.
 * Les options « Parfum » du schéma de sections/eloence-quiz.liquid doivent
 * reprendre ces mêmes identifiants.
 */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.ElQuizProfile = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  const PERFUMES = ['sables-obscurs', 'ombre-encens', 'liqueur-ambre', 'eveil-sucre'];

  /*
   * answers : parfum tagué par la réponse choisie à chaque question, dans l'ordre
   *           des questions — tableau ['sables-obscurs', …] ou objet {q1: …, q2: …}.
   *           Une réponse sans parfum (null, '', inconnu) ne rapporte aucun point.
   * Retour  : l'identifiant du parfum gagnant (toujours un des PERFUMES).
   *
   * 1 point par réponse. Égalité au score max → réponse à la 1re question (Notes),
   * puis à la dernière (Lieu), puis ordre de PERFUMES.
   */
  function computeProfile(answers, priority) {
    const order = priority && priority.length ? priority : PERFUMES;
    const list = Array.isArray(answers)
      ? answers
      : Object.keys(answers || {})
          .sort((a, b) => parseInt(a.replace(/\D/g, ''), 10) - parseInt(b.replace(/\D/g, ''), 10))
          .map((k) => answers[k]);

    const scores = new Map(order.map((p) => [p, 0]));
    list.forEach((p) => { if (scores.has(p)) scores.set(p, scores.get(p) + 1); });

    const max = Math.max(...scores.values());
    const tied = order.filter((p) => scores.get(p) === max);
    if (tied.length === 1) return tied[0];

    const tieBreakers = [list[0], list[list.length - 1]];
    for (const p of tieBreakers) if (tied.includes(p)) return p;
    return tied[0];
  }

  return { PERFUMES, computeProfile };
});
